"use client";
import styled from "../../../client-utils/styled/index.js";
import Box from "../../../components/atoms/Box/index.js";
import IconButtonAtom from "../../../components/atoms/IconButton/index.js";
import { SINGLE, DOUBLE } from "../../../constants/numbers.consts.js";
const coreComponentName = "SdbIconButtonGroup";
export const Root = styled(Box, {
    name: coreComponentName,
    slot: "Root",
})(({ theme }) => ({
    display: "flex",
    gap: theme.spacing(SINGLE),
}));
export const IconButton = styled(IconButtonAtom, {
    name: coreComponentName,
    slot: "IconButton",
})(({ theme }) => ({
    paddingTop: theme.spacing(DOUBLE),
    paddingBottom: theme.spacing(DOUBLE),
}));
